import { ErrorCodes, ConfigStrings } from 'src/app/utils/common-classes';
import { HttpParams } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../Auth/auth.service";
export class FolderService {
    constructor(httpClient, authService) {
        this.httpClient = httpClient;
        this.authService = authService;
    }
    getFolders(mediaFolderId, mediaTreeId) {
        let _self = this;
        return new Promise((resolve, reject) => {
            const headers = _self.authService.getHeaders();
            let params = new HttpParams();
            if (mediaFolderId) {
                params = params.append('parentFolderId', mediaFolderId);
            }
            params = params.append('mediaTreeId', mediaTreeId);
            _self.httpClient.get(ConfigStrings.API_URL + "/get-folders", { headers: headers, params: params }).subscribe((data) => {
                if (data) {
                    resolve(data);
                }
                else {
                    reject(new Error(ErrorCodes.UNKNOWN_ERROR));
                }
            }, (error) => {
                reject(error);
            });
        });
    }
    createFolder(name, parentFolderId, mediaTreeId) {
        let _self = this;
        return new Promise((resolve, reject) => {
            const headers = _self.authService.getHeaders();
            const body = {
                name: name,
                parentFolderId: parentFolderId,
                mediaTreeId: mediaTreeId
            };
            _self.httpClient.post(ConfigStrings.API_URL + "/create-folder", body, { headers: headers }).subscribe((data) => {
                if (data) {
                    resolve(data);
                }
                else {
                    reject(new Error(ErrorCodes.UNKNOWN_ERROR));
                }
            }, (error) => {
                reject(error);
            });
        });
    }
    renameFolder(name, mediaFolderId) {
        let _self = this;
        return new Promise((resolve, reject) => {
            const headers = _self.authService.getHeaders();
            const body = {
                mediaFolderId: mediaFolderId,
                name: name
            };
            _self.httpClient.post(ConfigStrings.API_URL + "/edit-folder", body, { headers: headers }).subscribe((data) => {
                if (data) {
                    resolve(data);
                }
                else {
                    reject(new Error(ErrorCodes.UNKNOWN_ERROR));
                }
            }, (error) => {
                reject(error);
            });
        });
    }
    moveFolder(mediaFolderId, parentFolderId) {
        let _self = this;
        return new Promise((resolve, reject) => {
            const headers = _self.authService.getHeaders();
            const body = {
                mediaFolderId: mediaFolderId,
                parentFolderId: parentFolderId ? parentFolderId : ""
            };
            _self.httpClient.post(ConfigStrings.API_URL + "/edit-folder", body, { headers: headers }).subscribe((data) => {
                if (data) {
                    resolve(data);
                }
                else {
                    reject(new Error(ErrorCodes.UNKNOWN_ERROR));
                }
            }, (error) => {
                reject(error);
            });
        });
    }
    deleteFolder(mediaFolderId) {
        let _self = this;
        return new Promise((resolve, reject) => {
            const headers = _self.authService.getHeaders();
            const body = {
                mediaFolderId: mediaFolderId
            };
            _self.httpClient.post(ConfigStrings.API_URL + "/delete-folder", body, { headers: headers }).subscribe(() => {
                resolve();
            }, (error) => {
                reject(error);
            });
        });
    }
    setFolderTranslation(mediaTranslation) {
        let _self = this;
        return new Promise((resolve, reject) => {
            const headers = _self.authService.getHeaders();
            _self.httpClient.post(ConfigStrings.API_URL + "/set-folder-translation", mediaTranslation, { headers: headers }).subscribe((data) => {
                if (data) {
                    resolve(data);
                }
                else {
                    reject(new Error(ErrorCodes.UNKNOWN_ERROR));
                }
            }, (error) => {
                reject(error);
            });
        });
    }
    deleteTranslation(mediaTranslation) {
        let _self = this;
        return new Promise((resolve, reject) => {
            const headers = _self.authService.getHeaders();
            _self.httpClient.post(ConfigStrings.API_URL + "/delete-folder-translation", mediaTranslation, { headers: headers }).subscribe((data) => {
                if (data) {
                    resolve(data);
                }
                else {
                    reject(new Error(ErrorCodes.UNKNOWN_ERROR));
                }
            }, (error) => {
                reject(error);
            });
        });
    }
}
FolderService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FolderService_Factory() { return new FolderService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AuthService)); }, token: FolderService, providedIn: "root" });
